import { useMemo } from 'react';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType } from 'components/list/DynamicListFilterUtils';

import { LOGS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants.js';

const ProductSyncLogList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, width: 70, show: false },
			{
				Header: 'sku',
				accessor: 'skuList',
				filterType: FilterType.string
			},

			{ Header: 'salesChannel', accessor: 'salesChannelName', filterType: FilterType.multiSelection },
			{
				Header: 'salesChannelCredentialsID',
				accessor: 'salesChannelCredentialsID',
				filterType: FilterType.multiSelection,
				show: false
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.multiSelection,
				renderCell: 'status',
				showOnMobile: true
			},

			{
				Header: 'createdBy',
				accessor: 'createdBy',
				filterType: FilterType.multiSelection,
				showOnMobile: true
			},
			{
				Header: 'createdDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				showOnMobile: true
			},
			{
				Header: 'errorDefinition',
				accessor: 'errorDefinition',
				filterType: FilterType.string
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.PRODUCT_SYNC_LOGS}
				columns={columns}
				fetchUrl={LOGS.GET_PRODUCT_SYNC_LOGS_LIST}
				defaultSort={defaultSort}
				exportName="productSyncLogs"
				infiniteScroll
			/>
		</TabTableContainer>
	);
};

export default ProductSyncLogList;
